<div class="container-tig-item">
    <div class="help-c-title">
        <h4>嵌入网页</h4>
    </div>
    <div>
        <h4>在网页html中嵌入字体</h4>
        <br>
        <p>在css代码中，我们主要使用的是font-face这个属性，它的主要功能就是把自己定义的Web字体嵌入到网页中。</p>
        <br>
        <pre>
            <ol style="line-height: 6px;">
                <li>@font-face {{ '{'}}</li>
                <li>&nbsp;&nbsp;&nbsp;&nbsp;font-family: &lt;YourWebFontName&gt;;</li>
                <li>&nbsp;&nbsp;&nbsp;&nbsp;font-family: &lt;YourWebFontName&gt;;</li>
                <li>&nbsp;&nbsp;&nbsp;&nbsp;{{'['}}font-weight: &lt;weight&gt;{{']'}};</li>
                <li>&nbsp;&nbsp;&nbsp;&nbsp;{{'['}}font-style: &lt;style&gt;{{']'}};</li>
                <li>{{ '}'}}&nbsp; 其中关于属性的解释（有些可能没有用到）</li>
                <br>
                <li>font-family：设置文本的字体名称。</li>
                <li>font-style：	设置文本样式。</li>
                <li>font-variant：设置文本是否大小写。</li>
                <li>font-weight：设置文本的粗细。</li>
                <li>font-stretch：设置文本是否横向的拉伸变形。</li>
                <li>font-size：设置文本字体大小。</li>
                <li>src：设置自定义字体的相对路径或者绝对路径，注意，此属性只能在@font-face规则里使用。</li>
            </ol>
        </pre>
        <br>
        <p>*.CSS文件内容</p>
        <br>
        <pre>
            <ol style="line-height: 6px;">
                <li>@<span class="tag_">font-face</span> {{ '{'}}</li>
                <li>&nbsp;&nbsp;&nbsp;&nbsp;font-family: '<span class="value_">OnonSoninSans</span>';</li>
                <li>&nbsp;&nbsp;&nbsp;&nbsp;src: <span class="url_">url</span>("<span class="value_">./assets/font/OnonSoninSans.woff</span>") <span class="url_">format</span>("<span class="value_">woff</span>"),  //IE9+,Firefox3.5+,Chrome6+,Safari3.6+,Opera11.1+</li>
                <li>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="url_">url</span>("<span class="value_">./assets/font/OnonSoninSans.ttf</span>") <span class="url_">format</span>("<span class="value_">truetype</span>"),  //IE9+,Firefox3.5+,Chrome4+,Safari3+,Opera10+,iOS Mobile Safari4.2+</li>
                <li>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="url_">url</span>("<span class="value_">./assets/font/OnonSoninSans.otf</span>") <span class="url_">format</span>("<span class="value_">opentype</span>"); // Firefox3.5+,Chrome4.0+,Safari3.1+,Opera10.0+,iOS Mobile Safari4.2+</li>
                <li>&nbsp;&nbsp;&nbsp;&nbsp;font-weight: normal;</li>
                <li>&nbsp;&nbsp;&nbsp;&nbsp;font-style: normal;</li>
                <li>{{ '}'}}</li>
            </ol>
        </pre>
        <p>
            所以根据这些，我们可以将字体文件放在指定的目录下，然后更改url的地址，对你的字体命名。然后，像正常字体一样去使用它吧。
        </p>
        <br>
        <br>
    </div>
</div>